export default __webpack_public_path__ + "static/data-vis-single-color-charts-light-5e64dd40e27de31fd84b49e8ee977542ac5feec8abe9eb7549d9ad915526d517.png";